import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const subjectTrackingApi = createApi({
  baseQuery,
  reducerPath: 'subjectTracking',
  endpoints: builder => ({
    subjectTrackingData: builder.mutation<any, any>({
      query: ({ study_id, site_id, country, from = -1, size = -1, data }) => ({
        url: `${formatString(endPoints.subjectTrackingData.getAll)}?application=CTMS&application_section=CONDUCT${
          study_id !== null ? `&study_id=${study_id}` : ''
        }${country !== null ? `&country=${country}` : ''}${site_id !== null ? `&site_id=${site_id}` : ''}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        method: 'POST',
        body: data
      })
    }),
    subjectTrackingPreScreenData: builder.query<any, any>({
      query: ({ prescreen_id, study_id, site_id, country }) => ({
        url: `${formatString(endPoints.subjectTrackingData.getPrescreenId, {
          key: urlKeys.prescreen_id,
          value: prescreen_id
        })}?application=CTMS&application_section=CONDUCT${study_id !== null ? `&study_id=${study_id}` : ''}${
          country !== null ? `&country=${country}` : ''
        }${site_id !== null ? `&site_id=${site_id}` : ''}`,
        method: 'GET'
      })
    })
  })
});

export const { useSubjectTrackingDataMutation, useSubjectTrackingPreScreenDataQuery } = subjectTrackingApi;
